import React, {Component} from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import classnames from 'classnames';
import styles from "./CategoryField.scss";
import RemoveButton from "../RemoveButton";
import AlgoliaCategoryField from "./AlgoliaCategoryField";
import { getPriceForTier } from 'lib/pricingCalculations';

class CategoryField extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    inputProps: PropTypes.object,
    meta: PropTypes.object,
    placeholder: PropTypes.string,
    config: PropTypes.object.isRequired,
    categories: PropTypes.array.isRequired,
    pricingTiers: ImmutablePropTypes.map.isRequired,
    currentPricingTier: PropTypes.number,
    maxPricingTier: PropTypes.number,
    className: PropTypes.string,
    onBlur: PropTypes.func.isRequired
  };

  idSalt = Math.random().toString(36).substring(2);

  onChange = (categoryId) => this.props.input.onChange(parseInt(categoryId, 10));
  clearSelection = () => {
    this.autocompleteInput().value = null
    this.props.input.onChange(null);
  }

  getControlID() {
    return `aa-search-${this.props.input.name.replace(/[^\w\s]/gi, '')}-${this.idSalt}`;
  }

  pricing(suggestion) {
    const { maxPricingTier, currentPricingTier, pricingTiers, config } = this.props;

    if (!maxPricingTier || maxPricingTier === undefined) { return ''; }
    if (suggestion.pricing_tier_level <= currentPricingTier || suggestion.pricing_tier_level <= maxPricingTier) { return ''; }

    const currency = config.get('default_currency');
    const price = parseFloat(getPriceForTier(suggestion.pricing_tier_level, pricingTiers, currency).get('amount', 0));
    if (!price || price === undefined) { return ''; }

    const formattedPrice = Math.ceil(price) === price ? price.toFixed() : price.toFixed(2);

    return `(${currency.get('symbol')}${formattedPrice})`;
  }

  autocompleteInput() {
    return document.getElementById(this.getControlID())
  }

  setInitialValue(){
    if (this.props.input.value) {
      const currentCategory = this.props.categories.find(e => e.id === parseInt(this.props.input.value, 10));
      this.autocompleteInput().value = currentCategory.name_with_path
    }
  }

  async componentDidMount() {
    const baseUrlWithProtocol = window.API_BASE_URL.startsWith("http://") || window.API_BASE_URL.startsWith("https://")
        ? window.API_BASE_URL
        : `https://${window.API_BASE_URL}`;

    this.setInitialValue()
    typeahead({
      input: this.autocompleteInput(),
      highlight: true,
      hint: false,
      source: {
        remote: {
          url: `${baseUrlWithProtocol}/categories/search?query=%QUERY&limit=8`,
          wildcard: '%QUERY',
          debounce: 300,
          requestOptions: {}
        },
        keys: ["name_with_path"],
        identity: (suggestion) => suggestion.id
      },
      limit: 8,
      templates: {
        suggestion: (suggestion, resultSet) => {
          const isHigherPlan = this.props.maxPricingTier && suggestion.pricing_tier_level > this.props.maxPricingTier;
          const withinPlan = this.props.maxPricingTier && suggestion.pricing_tier_level <= this.props.maxPricingTier;

          return `<div class="${styles.regular} ${isHigherPlan && styles.higherPlan} ${withinPlan && styles.withinPlan}">
                      <div class="row">
                        <div class="col-6">
                          <span class="text-muted">
                            ${suggestion.name_with_path}
                          </span>
                        </div>
                      </div>
                      <div class="info-row">
                        <span class="category-name">${suggestion.name}</span>
                        <span class="tier-info">
                          ${this.props.pricingTiers.get(suggestion.pricing_tier_level.toString()).get('name')}
                          Plan
                          <span class="tier-pricing">${this.pricing(suggestion)}</span>
                        </span>
                      </div>
                    </div>
                  `;
        },

        loader: () => {
          return `<div class="tt-loading">
                        Loading...
                </div>`
        },
        notFound: () => {
          return `<div>
                            Sorry we couldn't find your category. <br/><br/>
                            Try a different search term.
                   </div>`
        }
      },
      display: (item, event) => {
        if (event) {
          this.onChange(item.id)
        }
        return item.name_with_path;
      }
    });
  }

  render() {
    const {input} = this.props;

    return (
      <div className="tt-input-container">
        <input
          name={input.name}
          className={classnames('form-control', this.props.className)}
          id={this.getControlID()}
          onBlur={() => input.onBlur(input.value)}
          autoComplete="off"
          placeholder={this.props.placeholder}
        />
        {this.props.inputProps.clearable && this.props.input.value && <RemoveButton onClick={this.clearSelection} insideForm={true} />}
      </div>
    );
  }

}

const wrapper = (props, error, componentProps) => {
  if (props.config.get('new_categories_search', false)) {
    return <CategoryField {...props} {...componentProps} className={componentProps.className}/>
  }

  return <AlgoliaCategoryField {...props} {...componentProps} className={componentProps.className}/>
};

export default wrapper;


// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/CategoryField.jsx